import { AiOutlineSignature } from 'react-icons/ai';
import { AttendanceSheetStatusEnum } from '../../enums/attendance-sheet-status.enum';
import { IoMdCloseCircle } from 'react-icons/io';
import { MdQuestionMark } from 'react-icons/md';
import { PiNotePencilDuotone, PiSealCheckBold } from 'react-icons/pi';
import { TbClockHour3 } from 'react-icons/tb';

const corSim = '#000';
const corNao = '#eee';

interface AttendanceSheetStatusIconProps {
  status?: AttendanceSheetStatusEnum;
  color?: string;
}

export default function AttendanceSheetStatusIcon({
  status,
  color,
}: AttendanceSheetStatusIconProps) {
  switch (status) {
    case AttendanceSheetStatusEnum.EM_PREENCHIMENTO:
      return (
        <PiNotePencilDuotone
          size={24}
          title="Em preenchimento."
          color={` ${color || 'orange'}`}
        />
      );

    case AttendanceSheetStatusEnum.AGUARDANDO_ASSINATURA:
      return (
        <AiOutlineSignature
          size={24}
          title="Aguardando assinatura do responsável."
          color={` ${color || 'dodgerblue'}`}
        />
      );

    case AttendanceSheetStatusEnum.AGUARDANDO_REVISAO:
      return (
        <TbClockHour3
          size={24}
          title="Em revisão da subdefensoria."
          color={` ${color || 'springgreen'}`}
        />
      );

    case AttendanceSheetStatusEnum.CONCLUIDA:
      return (
        <PiSealCheckBold
          size={24}
          title="Concluída."
          color={` ${color || 'blue'}`}
        />
      );

    case AttendanceSheetStatusEnum.EM_CORRECAO:
      return (
        <IoMdCloseCircle
          size={24}
          title="Em correção."
          color={` ${color || 'lightsalmon'}`}
        />
      );
    default:
      return (
        <MdQuestionMark size={24} title="?" color={` ${color || 'gray'}`} />
      );
    // return (
    //   <TbLockCancel
    //     size={24}
    //     title="Não liberada."
    //     color={` ${color || 'gray'}`}
    //   />
    // );
  }
}

interface AttendanceSheetStatusIconByStatus {
  status?: AttendanceSheetStatusEnum;
  folhaStatus?: AttendanceSheetStatusEnum;
}

export function AttendanceSheetStatusIconByStatus({
  status,
  folhaStatus,
}: AttendanceSheetStatusIconByStatus) {
  return (
    <AttendanceSheetStatusIcon
      status={status}
      color={folhaStatus === status ? corSim : corNao}
    />
  );
}
